import React from "react";

interface MercosulPlateBadgeProps {
  plate: string;
  size?: "sm" | "md";
  className?: string;
}

export const MercosulPlateBadge: React.FC<MercosulPlateBadgeProps> = ({
  plate,
  size = "md",
  className = "",
}) => {
  const compact = size === "sm";

  return (
    <div
      className={`inline-flex flex-col overflow-hidden rounded-md border-2 border-zinc-900 dark:border-slate-200 bg-white dark:bg-white shadow-sm dark:shadow-md shrink-0 max-w-full ${className}`}
      title={plate}
    >
      <div
        className={`bg-blue-600 text-white font-bold tracking-[0.2em] text-center leading-none ${
          compact ? "text-[7px] py-px" : "text-[8px] sm:text-[9px] py-0.5"
        }`}
      >
        BRASIL
      </div>
      <div
        className={`font-mono font-bold tracking-[0.12em] sm:tracking-[0.18em] text-black leading-none whitespace-nowrap ${
          compact ? "px-1.5 py-0.5 text-[11px]" : "px-2 py-1 text-xs sm:px-2.5 sm:text-sm"
        }`}
      >
        {plate}
      </div>
    </div>
  );
};
